import { useContext, useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { log } from ".";
import { ChatConfigContext } from "../config";
import { sendGreeting, sendVisitorInfo } from "../store/actions";
import { ChatState } from "../store/ChatState";
import { ChatServerDispatch, useChatServerDispatch } from "./useChatServerDispatch";

interface ServerVisitorSnapshot {
    readonly dispatch: ChatServerDispatch;
    /**
     * @deprecated Use userId
     */
    readonly visitorId: string;
    readonly accessToken?: string;
    readonly userId: string;
    readonly attributes?: Record<string, unknown>;
}

function useChatServerVisitorId(): ServerVisitorSnapshot {

    const dispatch = useChatServerDispatch();
    const clientVisitorId = useSelector<ChatState, string>(state => {
        return state.visitorId || state.userId
    });
    const visitorAccessToken = useSelector<ChatState, string>(state => state.accessToken);

    const attributes = useSelector<ChatState, Record<string, unknown>>(state => state.attributes);

    return useMemo<ServerVisitorSnapshot>(() => ({
        dispatch,
        visitorId: clientVisitorId,
        accessToken: visitorAccessToken,
        userId: clientVisitorId,
        attributes
    }), [dispatch, clientVisitorId, visitorAccessToken, attributes]);
}

//send whenever server settings or visitor id changes

export default function useGreeting(active: boolean): void {
    const curr = useChatServerVisitorId();
    const snapshotRef = useRef<ServerVisitorSnapshot | null>(null);

    const ctx = useContext(ChatConfigContext);
    // Handle null context (e.g., in preview mode)
    const isAdmin = ctx?.env?.isAdmin ?? false;

    const sessionId = useSelector<ChatState, string>(state => state.sessionId);

    useEffect(() => {
        if (active) {
            if (snapshotRef.current !== curr) {
                snapshotRef.current = curr;

                if (curr.visitorId) {
                    curr.dispatch(sendVisitorInfo({
                        name: "Visitor",
                        visitorId: curr.visitorId,
                        userId: curr.userId,
                        accessToken: curr.accessToken,
                        attributes: { ...curr.attributes, currentUrl: window.location.href }
                    }, sessionId));

                    if (!isAdmin) {
                        const timeoutId = setTimeout(() => {
                            const greetingAction = sendGreeting();
                            curr.dispatch(greetingAction);
                        }, 1000);

                        return () => {
                            clearTimeout(timeoutId);
                        };
                    } else {
                        log("Admin widget. Not sending greeting.");
                    }
                }
            }
        }
        return undefined;
    }, [curr, active, isAdmin]);
}